import React from 'react';
import { ReactComponent as FlagDE } from './assets/Language-DE-Bright.svg';
import { ReactComponent as FlagEN } from './assets/Language-EN-Bright.svg';

const LanguageFlag = (props) => (
  <div className={props.lang}>{props.lang === 'de' ? <FlagDE /> : <FlagEN />}</div>
);

export default LanguageFlag;
